export default __webpack_public_path__ + "static/media/gyptech_reg_round.0eaf2eaa.png";